import { createFileRoute } from '@tanstack/react-router';
import { APP_PATHS, PAGE_PATHS } from '../../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/incidents/settings/rule-set/$id/$ruleIndex/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.RULE_SET, app: APP_PATHS.INCIDENTS });
    context.validatePermissions({ isAllowed, preload });
  },
});
